import React from "react";

interface ListIllustrationProps {
  className?: string;
}

export const ListIllustration: React.FC<ListIllustrationProps> = ({
  className = "h-24 w-24",
}) => {
  return (
    <svg
      className={className}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      {/* Paper */}
      <rect
        x="28"
        y="18"
        width="64"
        height="84"
        rx="6"
        className="fill-white stroke-secondary-300"
        strokeWidth="2"
      />
      {/* Checkboxes and lines */}
      <rect
        x="38"
        y="34"
        width="10"
        height="10"
        rx="2"
        className="fill-success-100 stroke-success-500"
        strokeWidth="2"
      />
      <path
        d="M41 39L44 42L49 36"
        className="stroke-success-600"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="56"
        y="38"
        width="26"
        height="3"
        rx="1.5"
        className="fill-secondary-300"
      />
      <rect
        x="38"
        y="54"
        width="10"
        height="10"
        rx="2"
        className="fill-success-100 stroke-success-500"
        strokeWidth="2"
      />
      <path
        d="M41 59L44 62L49 56"
        className="stroke-success-600"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="56"
        y="58"
        width="20"
        height="3"
        rx="1.5"
        className="fill-secondary-300"
      />
      <rect
        x="38"
        y="74"
        width="10"
        height="10"
        rx="2"
        className="fill-white stroke-secondary-300"
        strokeWidth="2"
      />
      <rect
        x="56"
        y="78"
        width="30"
        height="3"
        rx="1.5"
        className="fill-secondary-300"
      />
      <rect
        x="38"
        y="94"
        width="10"
        height="10"
        rx="2"
        className="fill-white stroke-secondary-300"
        strokeWidth="2"
      />
      <rect
        x="56"
        y="98"
        width="24"
        height="3"
        rx="1.5"
        className="fill-secondary-300"
      />
    </svg>
  );
};

export default ListIllustration;
